import TabbedWrapperHeader from "routes/TabbedWrapperRouter/TabbedWrapperHeader/TabbedWrapperHeader";
import CannedEmailResponses from "../../CannedEmailResponses/CannedEmailResponses";
import { CANNED_RESPONSE_READ_PERMISSION } from "components/dashboard/KnowledgeBase/CannedResponses/permissions";

const CannedResponsesTab = () => {
    const tabbledRoutes = [
        {
            title: "Canned emails",
            path: "/t-sam/responses/emails",
            component: CannedEmailResponses,
            baseResources: CANNED_RESPONSE_READ_PERMISSION,
        },
        {
            title: "Canned replies",
            path: "/t-sam/responses/replies",
            component: CannedEmailResponses,
            baseResources: CANNED_RESPONSE_READ_PERMISSION,
        },
        {
            title: "Canned mentions",
            path: "/t-sam/responses/mentions",
            component: CannedEmailResponses,
            baseResources: CANNED_RESPONSE_READ_PERMISSION,
        },
    ];

    return <TabbedWrapperHeader tabbedRoutes={tabbledRoutes} />;
};

export default CannedResponsesTab;
